// extracted by mini-css-extract-plugin
export default {"button":"UserFeedbackButton_button__pVtVg","text":"UserFeedbackButton_text__nJjpQ"};